import { render, staticRenderFns } from "./ListingTypeLogo.vue?vue&type=template&id=2a29ce1c&"
import script from "./ListingTypeLogo.vue?vue&type=script&lang=js&"
export * from "./ListingTypeLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TooltipIcon: require('/app/appsumo/nuxt/components/common/TooltipIcon.vue').default})
